import { marked } from 'marked';
import classNames from 'classnames';
import dompurify from 'dompurify';
import './RichTextDisplay.scss';

interface RichTextDisplayProps {
    text: string;
    id?: string;
    className?: string;
}

export function RichTextDisplay({ id, className, text }: RichTextDisplayProps) {
    if (!text) return null;

    return (
        <div
            id={id}
            data-testid={id}
            className={classNames('RichTextDisplay', className)}
            dangerouslySetInnerHTML={{ __html: dompurify.sanitize(marked(text)) }}
        />
    );
}
